import React from 'react';

export default () => {
  return (
    <div>
      Post Type Not Supported.
    </div>
  );
}
